// @flow

import React from 'react';
import glamorous, { Div, Span } from 'glamorous';
import colorUtils from 'color';
import worldMap from 'app/images/globalLeaderboard/world-map.png';
import UCAvatar from './UCAvatar';
import WinnerDetails from './WinnerDetails';

type Props = {
  competitionName: string,
  entries: Array<Object>,
};

const WorldMapContainer = glamorous.div(props => ({
  position: 'relative',

  [props.theme.mediaQuery.desktopAndUp]: {
    paddingRight: props.theme.spacing.huge,
  },
}));

const WorldMap = glamorous(props => (
  <img alt="world map" src={worldMap} {...props} />
))({
  width: 367,
  height: 225,
});

const Username = glamorous.span(props => ({
  fontSize: props.theme.fontSize.medium,
}));

const Score = glamorous.span(props => ({
  color: props.theme.color.green,
}));

const CompTitle = glamorous.div(props => ({
  fontSize: props.theme.fontSize.default,
  textTransform: 'uppercase',
  fontWeight: props.theme.fontWeight.bold,
}));

const StyledWinnerDetails = glamorous(WinnerDetails)({
  padding: 2,
  paddingLeft: 10,
  paddingRight: 10,
});

const TopDetails = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

const HallOfFameContentInnerDiv = glamorous.div(props => ({
  backgroundColor: colorUtils(props.theme.color.panel).alpha(0.7).string(),
  padding: props.theme.spacing.default,
}));

const AvatarMapContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}, props => ({
  [props.theme.mediaQuery.desktopAndUp]: {
    flexDirection: 'row',
  },
}));

function HallOfFameContentInner({
  competitionName,
  entries,
}: Props) {
  // [MC] TODO - account for multiple entries!!
  const entry = entries[0];
  const score = entry.globalScore;
  const originalEntries = entry.originalEntries;
  return (
    <HallOfFameContentInnerDiv>
      <TopDetails>
        <CompTitle>{competitionName}</CompTitle>
        <Div display="flex" paddingBottom={10} alignItems="center">
          <Username>{entry.userName}</Username>
          <Span paddingRight={10} paddingLeft={10}>|</Span>
          <Score>{score}</Score>
        </Div>
        <Div display="flex" flexDirection="column" alignItems="flex-start">
          {originalEntries.map((originalEntry, i) => (
            <StyledWinnerDetails
              challengeId={originalEntry.challengeId}
              date={originalEntry.challengeStartTime}
              key={originalEntry.id}
              match={originalEntry.challengeName}
              number={i + 1}
              score={originalEntry.globalScore}
            />
          ))}
        </Div>
      </TopDetails>
      <Div display="flex" alignItems="center" justifyContent="center">
        <AvatarMapContainer>
          <UCAvatar avatar={entry.userAvatar} />
          <WorldMapContainer>
            <WorldMap />
          </WorldMapContainer>
        </AvatarMapContainer>
      </Div>
    </HallOfFameContentInnerDiv>
  );
}

export default HallOfFameContentInner;
